"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateLotteryNFTForm = void 0;
const default_contract_action_1 = require("@components/default-contract-action");
const token_select_1 = require("@components/token-select");
const lottery_hooks_1 = require("@hooks/contracts/lottery.hooks");
const form_hooks_1 = require("@hooks/form.hooks");
const translation_hooks_1 = require("@hooks/translation.hooks");
const currency_input_1 = require("@shared-modules/components/currency-input");
const date_picker_1 = require("@shared-modules/components/date-picker");
const text_input_1 = require("@shared-modules/components/text-input");
const react_1 = __importDefault(require("react"));
const helper_1 = require("./helper");
require("./styles.scss");
const CreateLotteryNFTForm = (props) => {
    var _a;
    const { token, onClose } = props;
    const translator = (0, translation_hooks_1.useComponentTranslation)("createLotteryNFTForm");
    const commonTranslator = (0, translation_hooks_1.useCommonTranslation)();
    const createLottery = (0, lottery_hooks_1.useCreateLottery)(token.tokenId);
    const { form, fieldHandlers, submit, validationResults } = (0, form_hooks_1.useForm)({
        initialData: helper_1.DEFAULT_FORM,
        validators: (0, helper_1.createValidator)(commonTranslator),
        submit: (form, validation) => __awaiter(void 0, void 0, void 0, function* () {
            if (validation.isValid) {
                const { blockNumber } = yield createLottery(form.maxTicket, form.ticketPrice, form.endDate, form.paymentToken);
                onClose(blockNumber);
            }
        }),
    });
    const [approveState, approve] = (0, lottery_hooks_1.useLotteryApprove)(token.tokenId, token.contractAddress);
    return (react_1.default.createElement("div", { className: "c-create-lottery-nft-form" },
        react_1.default.createElement("div", { className: "c-create-lottery-nft-form__header" }, translator("title")),
        react_1.default.createElement("div", { className: "c-create-lottery-nft-form__field" },
            react_1.default.createElement(token_select_1.TokenSelect, { label: translator("paymentTokenLabel"), error: validationResults.results.paymentToken, onChange: fieldHandlers.paymentToken, value: form.paymentToken })),
        react_1.default.createElement("div", { className: "c-create-lottery-nft-form__field" },
            react_1.default.createElement(text_input_1.TextInput, { label: translator("maxTicketLabel"), placeholder: translator("maxTicketPlaceholder"), value: form.maxTicket, handleChange: fieldHandlers.maxTicket, type: "positiveInteger", error: validationResults.results.maxTicket })),
        react_1.default.createElement("div", { className: "c-create-lottery-nft-form__field" },
            react_1.default.createElement(currency_input_1.CurrencyInput, { label: translator("ticketPriceLabel"), placeholder: translator("ticketPricePlaceholder"), currencySymbol: (_a = form.paymentToken) === null || _a === void 0 ? void 0 : _a.symbol, value: form.ticketPrice, onChange: fieldHandlers.ticketPrice, decimals: 2, error: validationResults.results.ticketPrice })),
        react_1.default.createElement("div", { className: "c-create-lottery-nft-form__field" },
            react_1.default.createElement(date_picker_1.DatePicker, { timeGranularity: 1, label: translator("endDateLabel"), minDate: new Date(), date: form.endDate, onChange: fieldHandlers.endDate, showTime: true, error: validationResults.results.endDate })),
        react_1.default.createElement(default_contract_action_1.DefaultContractAction, { onApprove: approve, actionHandler: submit, actionName: translator("createLotteryButton"), approveState: approveState })));
};
exports.CreateLotteryNFTForm = CreateLotteryNFTForm;
